// ════════════════════════════════
// sounds.ts — TolkX Sound Engine
// ════════════════════════════════

let audioCtx: AudioContext | null = null;

const getCtx = () => {
  if (!audioCtx) audioCtx = new AudioContext();
  return audioCtx;
};

// ── Discord-style message received ──
export const playMessageSound = () => {
  try {
    const ctx = getCtx();
    const now = ctx.currentTime;

    const osc1 = ctx.createOscillator();
    const osc2 = ctx.createOscillator();
    const gainNode = ctx.createGain();

    osc1.connect(gainNode);
    osc2.connect(gainNode);
    gainNode.connect(ctx.destination);

    osc1.type = 'sine';
    osc2.type = 'sine';

    osc1.frequency.setValueAtTime(1200, now);
    osc1.frequency.exponentialRampToValueAtTime(900, now + 0.1);

    osc2.frequency.setValueAtTime(800, now + 0.05);
    osc2.frequency.exponentialRampToValueAtTime(1100, now + 0.15);

    gainNode.gain.setValueAtTime(0, now);
    gainNode.gain.linearRampToValueAtTime(0.18, now + 0.02);
    gainNode.gain.exponentialRampToValueAtTime(0.001, now + 0.3);

    osc1.start(now);
    osc1.stop(now + 0.3);
    osc2.start(now + 0.05);
    osc2.stop(now + 0.3);
  } catch (e) {
    console.warn('Sound error:', e);
  }
};

// ── Typing indicator bloop — 3 ascending tones synced with dots ──
export const playTypingSound = () => {
  try {
    const ctx = getCtx();
    const now = ctx.currentTime;
    const tones = [520, 660, 820];

    tones.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);

      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, now + i * 0.12);

      const start = now + i * 0.12;
      gain.gain.setValueAtTime(0, start);
      gain.gain.linearRampToValueAtTime(0.08, start + 0.03);
      gain.gain.exponentialRampToValueAtTime(0.001, start + 0.15);

      osc.start(start);
      osc.stop(start + 0.15);
    });
  } catch (e) {
    console.warn('Sound error:', e);
  }
};